export enum AIChecks {
  SCZSZS = 1,

}
